import { Validator } from 'vee-validate'
import { vp } from '@/tools/helpers'

export const rules = {

}

export const validator = new Validator(rules)

export const showServerValidationErrors = (data) => {
  const { errors, msg } = data
  let message = ''
  if (errors) {
    message = ''
    let errorFields = Object.keys(errors)

    for (let i = 0; i < errorFields.length; i++) {
      let field = errorFields[i]

      for (let error of errors[field]) {
        message += `${error}<br>`
      }
    }
  } else if (msg) {
    message = msg
  }

  vp.$notify.error('Validation Error.', message)
}
